import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const MoltenDripAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number,
  timeSeconds: number
) => {
  const drips = 24;
  const t = timeSeconds;
  for (let i = 0; i < drips; i++) {
    const ang = (i / drips) * Math.PI * 2;
    const r = getRadiusAtAngle(ang, e, e.maxRadius);
    const dx = e.pos.x + Math.cos(ang) * r;
    const dy = e.pos.y + Math.sin(ang) * r + (1000 * t * t);
    ctx.beginPath(); ctx.arc(dx, dy, 12 * (1 - progress), 0, Math.PI * 2); ctx.fill();
  }
};

registerBlastAnimation('MOLTEN_DRIP', MoltenDripAnimation);
